/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Booking_BodyInputs */

const en_features_booking_body = /** @type {(inputs: Features_Booking_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free times straight from your coach's calendar. Pick a day and a time, pay in the app, and the reminder arrives on its own.`)
};

const pl_features_booking_body = /** @type {(inputs: Features_Booking_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolne godziny prosto z kalendarza trenera. Wybierasz dzień i godzinę, płacisz w aplikacji, a przypomnienie przychodzi samo.`)
};

/**
* | output |
* | --- |
* | "Free times straight from your coach's calendar. Pick a day and a time, pay in the app, and the reminder arrives on its own." |
*
* @param {Features_Booking_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_booking_body = /** @type {((inputs?: Features_Booking_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Booking_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_booking_body(inputs)
	return en_features_booking_body(inputs)
});